<script>
  import DailyTips from "@/components/daily-tips/Index.vue";
  import Tips from "../icons/Tips.vue";

  export default {
    components: { Tips, DailyTips },

    computed: {
      showDailyTipsButton() {
        return this.$root.checkPermission({
          permission: this.$permissions.VIEW_TIPS,
        }) && !this.$store.getters["User/hasLimitedAccess"]
      },
    },
  }
</script>

<template>
  <DailyTips v-if="showDailyTipsButton">
    <div
      class="base-tooltip cursor-pointer d-flex justify-content-center align-items-center"
      :data-tooltip="$t('titles.dailyTips')"
    >
      <Tips />
    </div>
  </DailyTips>
</template>

<style scoped lang="sass">

</style>
